const INSTRUCTOR_SEARCH_LIMIT = 50;

function readFirst(...values) {
   for (const value of values) {
      if (value !== "" && value != null) return value;
   }
   return "";
}

function personName(value) {
   if (!value || typeof value !== "object") return "";

   const fullName = readFirst(
      value.fullName,
      value.name,
      value.displayName,
      value.username,
      value.userName,
   );
   if (fullName) return String(fullName).trim();

   return [value.firstName, value.lastName].filter(Boolean).join(" ").trim();
}

export function normalizeGearboxValue(value) {
   const normalized = String(value || "")
      .trim()
      .toLowerCase();
   if (normalized.includes("auto")) return "automatic";
   return "manual";
}

export function gearboxLabel(value) {
   return normalizeGearboxValue(value) === "automatic" ? "Automat" : "Manual";
}

export function buildSelectableInstructorOptions({
   instructorOptions = [],
   selectedId = "",
   fallbackLabel = "Instructor",
}) {
   const selected = String(selectedId || "").trim();
   const normalized = (instructorOptions || [])
      .map((option) => {
         const raw =
            option?.raw && typeof option.raw === "object" ? option.raw : {};
         const value = String(option?.value ?? "").trim();
         const label = String(
            personName(raw) || option?.label || option?.value || "",
         ).trim();
         const sector = String(
            readFirst(
               option?.sector,
               raw.sector,
               raw.profile?.sector,
               raw.extra?.sector,
            ),
         ).trim();
         const profileGearbox = readFirst(
            option?.gearbox,
            raw.gearbox,
            raw.gearboxType,
            raw.car?.gearbox,
            raw.car?.gearboxType,
            raw.cars?.[0]?.gearbox,
            raw.cars?.[0]?.gearboxType,
         );
         const phone = String(
            readFirst(
               option?.phone,
               raw.phone,
               raw.user?.phone,
               raw.profile?.phone,
               raw.extra?.phone,
            ),
         ).trim();

         return {
            value,
            label,
            sector,
            gearbox: profileGearbox ? normalizeGearboxValue(profileGearbox) : "",
            phone,
            raw,
         };
      })
      .filter((option) => option.value);

   if (selected && !normalized.some((option) => option.value === selected)) {
      normalized.push({
         value: selected,
         label: fallbackLabel || "Instructor",
         sector: "",
         gearbox: "",
         phone: "",
         raw: {},
      });
   }

   return normalized;
}

export function filterInstructorOptions(options, query, limit = INSTRUCTOR_SEARCH_LIMIT) {
   const normalizedQuery = String(query || "").trim().toLowerCase();
   const matching = normalizedQuery
      ? (options || []).filter((option) =>
           `${option.label} ${option.phone} ${option.sector} ${option.value}`
              .toLowerCase()
              .includes(normalizedQuery),
        )
      : options || [];

   return {
      items: matching.slice(0, limit),
      limited: matching.length > limit,
      isSingleMatch: matching.length === 1,
   };
}

export { INSTRUCTOR_SEARCH_LIMIT };
